import React from "react";

export default function Contact() {
  return (
    <footer id="footer" className="footer blackbg">
      <div className="footer-columns-cont">
      <div className="footer-column">
      <div className="logo-cont footer-logo">
          <div className="row0gap rotate">
            <p className="logo-corchete1">[</p>
            <p className="logo-cero">0</p>
            <p className="logo-corchete2">]</p>
          </div>
          <div className="title-cont">
            <p className="title">FOJA</p>
            <p className="title red-and-black">CERO</p>
            <p className="title-subtext">PRODUCCIONES</p>
          </div>
        </div>
      </div>
 
        <div className="footer-column">
        <p className="footer-text">Quiénes somos »</p>
        <p className="footer-text">Periodistas »</p>
        <p className="footer-text">Programas »</p>
        <p className="footer-text">Productos »</p>
      </div>
      <div className="footer-column">
        <p className="footer-text">fojaceroproducciones@gmail.com</p>
        <p className="footer-text">Maure 3515, 6°D, CABA</p>
        <p className="footer-text">Teléfonos: 4555-7117 / 4555-0530</p>
      </div>

      </div>

      <div className="footer-row">
        <p className="footer-text">Desarrollo web por</p>
        <p className="footer-text">www.tomitorresdev.com.ar</p>
      </div>
    </footer>
  );
}
